__turbopack_context__.v({
  "tbody": "mantineTable-module-scss-module__1j8Euq__tbody",
  "td": "mantineTable-module-scss-module__1j8Euq__td",
  "th": "mantineTable-module-scss-module__1j8Euq__th",
  "thead": "mantineTable-module-scss-module__1j8Euq__thead",
  "tr": "mantineTable-module-scss-module__1j8Euq__tr",
});
